import styles from './Pagination.module.css';

interface PaginationProps {
  page: number;
  totalPages: number;
  /** Optional count to show in parentheses, e.g. "(47 fields)" */
  total?: number;
  /** Label for the count, defaults to "total" */
  label?: string;
  onPageChange: (page: number) => void;
  className?: string;
}

/** Simple prev/next pagination. Returns null when totalPages <= 1. */
export default function Pagination({
  page,
  totalPages,
  total,
  label = 'total',
  onPageChange,
  className = '',
}: PaginationProps) {
  if (totalPages <= 1) return null;

  const info =
    total !== undefined
      ? `Page ${page} of ${totalPages} (${total} ${label})`
      : `Page ${page} of ${totalPages}`;

  return (
    <div className={`${styles.pagination} ${className}`.trim()}>
      <button className={styles.btn} disabled={page === 1} onClick={() => onPageChange(page - 1)}>
        ‹ Prev
      </button>
      <span className={styles.info}>{info}</span>
      <button
        className={styles.btn}
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Next ›
      </button>
    </div>
  );
}
